import React from "react";
import { Link } from "react-router-dom";

import heroPattern from "../../../../assets/hero-pattern.png";
import heroPlay from "../../../../assets/hero-play.png";
import CarouselWrapper from "./Carousel";
import "./styles.scss";

export default function Hero({ banner }) {
  return (
    <section className="psre-satu">
      <div className="container">
        <div className="wrapper-hero row" style={{ flexWrap: "wrap" }}>
          <div
            className="col-lg-7 col-md-12 col-sm-12 col-12 my-5 mx-0 order-lg-last"
            style={{ paddingRight: 0 }}
          >
            <div
              style={{ height: "100%", display: "flex", alignItems: "center" }}
            >
              <CarouselWrapper data={banner} />
            </div>
          </div>
          <div
            className="col-lg-5 col-md-12 col-sm-12 col-12 my-3 order-lg-first"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <p className="p-nunito" style={{ color: "#1672BD" }}>
              Selamat Datang di Zona
            </p>
            <h1 className="h1-nunito" style={{ marginBottom: "32px" }}>
              Layanan <span style={{ color: "#1672BD" }}>Digital</span>{" "}
              Terpercaya
            </h1>
            <p
              className="p-nunito"
              style={{ color: "black", maxWidth: "440px" }}
            >
              Penyelenggara Sertifikasi Elektronik (PSrE) bertujuan untuk
              menyediakan jasa sertifikat elektronik dan tanda tangan digital
              yang efisien, praktis dan terpercaya bagi ekosistem digital di
              Indonesia
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
              }}
            >
              <Link
                onClick={() => console.log("PENCET1")}
                style={{
                  backgroundColor: "#1672BD",
                  marginRight: "12px",
                  color: "white",
                  border: "1px solid #1672BD",
                }}
                className="nav-link btn p-nunito btn-hero"
                to="/apaitu"
              >
                Pelajari Selengkapnya
              </Link>
              {/* <button
                type="button"
                onClick={() => console.log("PENCET2")}
                style={{
                  backgroundColor: "white",
                  color: "black",
                  border: "1px solid black",
                }}
                className="p-nunito btn-hero"
              >
                Pilih Layanan PSrE
              </button> */}
            </div>
          </div>
        </div>
        <div className="d-md-none d-block" style={{ height: 20 }} />
      </div>
    </section>
  );
}
